import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import Card from '../../components/common/Card'
import Input from '../../components/common/Input'
import Button from '../../components/common/Button'
import Alert from '../../components/common/Alert'

const TwoFactorPage = () => {
  const navigate = useNavigate()
  const { loginStep2, sessionToken } = useAuth()
  const [code, setCode] = useState('')
  const [isBackupCode, setIsBackupCode] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  // Redirect if no session token
  if (!sessionToken) {
    navigate('/login')
    return null
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      const data = await loginStep2(code, isBackupCode)

      // Show backup codes warning if running low
      if (data.backup_codes_remaining !== undefined && data.backup_codes_remaining <= 3) {
        // You might want to show a warning here
        console.warn(`Only ${data.backup_codes_remaining} backup codes remaining`)
      }

      // Redirect to home
      navigate('/')
    } catch (err) {
      setError(
        err.response?.data?.detail || 'Verification failed. Please check your code and try again.'
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Two-Factor Authentication</h1>
          <p className="text-gray-600 mt-2">Enter the code from your authenticator app</p>
        </div>

        <Card>
          {error && <Alert type="error" message={error} onClose={() => setError('')} />}

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label={isBackupCode ? 'Backup Code' : 'Authentication Code'}
              type="text"
              name="code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder={isBackupCode ? 'XXXX-XXXX-XXXX' : '123456'}
              required
              autoFocus
            />

            <div className="flex items-center">
              <input
                type="checkbox"
                id="isBackupCode"
                checked={isBackupCode}
                onChange={(e) => setIsBackupCode(e.target.checked)}
                className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
              />
              <label htmlFor="isBackupCode" className="ml-2 text-sm text-gray-700">
                Using a backup code
              </label>
            </div>

            <Button type="submit" fullWidth disabled={loading}>
              {loading ? 'Verifying...' : 'Verify'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/login')}
              className="text-sm text-primary-600 hover:text-primary-700"
            >
              ← Back to login
            </button>
          </div>
        </Card>
      </div>
    </div>
  )
}

export default TwoFactorPage
